export const environment = {
  production: false,
  server: {backendUrl: 'https://api.driver.qualityfrotas.com.br/'}
};
